import { AfterViewChecked, ChangeDetectorRef, Component, OnInit, inject } from '@angular/core';
import { environment } from '../environments/environment';
import { SessionService } from './_shared/data-access/session.service';
@Component({
  selector: 'app-root',
  standalone: false,
  template: `@if (sessionService.patron$ | async) {
      <app-header-wrapper />
    }
    <router-outlet /> <app-modal-wrapper />`,
})
export class AppComponent implements OnInit, AfterViewChecked {
  protected sessionService = inject(SessionService);

  constructor(private cdReference: ChangeDetectorRef) {}

  ngOnInit() {
    if (environment.analytics && environment.analytics.mmc) {
      this.loadGtagScripts(environment.analytics.mmc);
    }
    if (environment.analytics && environment.analytics.club.length > 0) {
      for (const tag of environment.analytics.club) {
        this.loadGTMScripts(tag);
      }
    }
  }

  ngAfterViewChecked() {
    this.cdReference.detectChanges();
  }
  /**
   * Loads Google Analytics (gtag.js) scripts dynamically.
   *
   * - Adds the `gtag.js` script to the document head asynchronously.
   * - Initializes the Google Analytics configuration with the provided `analyticsId`.
   *
   * @param  analyticsId - The Google Analytics ID to initialize.
   */
  loadGtagScripts(analyticsId: string) {
    const node = document.createElement('script');
    node.src = `https://www.googletagmanager.com/gtag/js?id=${analyticsId}`;
    node.async = true;
    node.type = 'text/javascript';
    document.querySelectorAll('head')[0].append(node);
    const node2 = document.createElement('script');
    node2.innerHTML = `window.dataLayer = window.dataLayer || [];
                      function gtag(){dataLayer.push(arguments);}
                      gtag('js', new Date());
                      gtag('config', '${analyticsId}');`;
    node2.type = 'text/javascript';
    document.querySelectorAll('head')[0].append(node2);
  }
  /**
   * Loads Google Tag Manager (GTM) scripts dynamically.
   *
   * - Adds the GTM script to the document head and initializes GTM with the provided `analyticsId`.
   * - Adds a `noscript` iframe to the document body for GTM fallback support in browsers with JavaScript disabled.
   *
   * @param  analyticsId - The Google Tag Manager ID to initialize.
   */
  loadGTMScripts(analyticsId: string) {
    const nodeHeadGTM = document.createElement('script');
    nodeHeadGTM.innerHTML = `
    (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
    new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
    j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
    'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
    })(window,document,'script','dataLayer', '${analyticsId}');
    `;
    document.querySelectorAll('head')[0].append(nodeHeadGTM);
    const nodeBodyGTM = document.createElement('noscript');
    nodeBodyGTM.innerHTML = `
    <iframe src=https://www.googletagmanager.com/ns.html?id=${analyticsId}
    height="0" width="0" style="display:none;visibility:hidden"></iframe>`;
    document.querySelectorAll('body')[0].append(nodeBodyGTM);
  }
}
